<template>
  <header class="absolute inset-x-0 top-0 z-50">
    <nav class="flex items-center justify-between p-6 lg:px-8" aria-label="Global">
      <div class="flex lg:flex-1">
        <a href="#" class="-m-1.5 p-1.5">
          <span class="sr-only">Your Company</span>
          <img class="h-8 w-auto" src="../assets/logo.png" alt="" />
        </a>
      </div>
      <div class="flex lg:hidden">
        <button type="button" class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-200" @click="mobileMenuOpen = true">
          <span class="sr-only">Open main menu</span>
          <Bars3Icon class="size-6" aria-hidden="true" />
        </button>
      </div>
      <div class="hidden lg:flex lg:gap-x-12">
        <a v-for="item in navigation" :key="item.name" :href="item.href" class="text-sm/6 font-semibold text-white px-3 py-2 rounded-full transition-colors duration-300 hover:bg-[#4540b6]" :class="{'bg-[#4540b6]': currentPath === item.href}">{{ item.name }}</a>
      </div>
      <div class="hidden lg:flex lg:flex-1 lg:justify-end">
        <!-- <a href="#" class="text-sm/6 font-semibold text-white px-3 py-2 rounded-full transition-colors duration-300 hover:bg-[#4540b6]">Log in <span aria-hidden="true">&rarr;</span></a> -->
      </div>
    </nav>

    <!-- The mobile menu is now controlled with simple JavaScript and v-if -->
    <div v-if="mobileMenuOpen" class="fixed inset-0 z-50 lg:hidden">
      <!-- Backdrop with a fade effect -->
      <div class="fixed inset-0 bg-gray-900/80 transition-opacity duration-300 ease-in-out" @click="mobileMenuOpen = false"></div>
      
      <!-- Mobile menu panel with a slide-in animation -->
      <div class="fixed inset-y-0 right-0 w-full overflow-y-auto bg-gray-900 p-6 transition-transform duration-300 ease-in-out transform" :class="mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'">
        <div class="flex items-center justify-between">
          <a href="#" class="-m-1.5 p-1.5">
            <span class="sr-only">Your Company</span>
            <img class="h-8 w-auto" src="https://tailwindcss.com/plus-assets/img/logos/mark.svg?color=indigo&shade=500" alt="" />
          </a>
          <button type="button" class="-m-2.5 rounded-md p-2.5 text-gray-200" @click="mobileMenuOpen = false">
            <span class="sr-only">Close menu</span>
            <XMarkIcon class="size-6" aria-hidden="true" />
          </button>
        </div>
        <div class="mt-6 flow-root">
          <div class="-my-6 divide-y divide-white/10">
            <div class="space-y-2 py-6">
              <a v-for="item in navigation" :key="item.name" :href="item.href" class="-mx-3 block rounded-full px-3 py-2 text-base/7 font-semibold text-white transition-colors duration-300 hover:bg-[#4540b6]" :class="{'bg-[#4540b6]': currentPath === item.href}">{{ item.name }}</a>
            </div>
            <div class="py-6">
              <!-- <a href="#" class="-mx-3 block rounded-full px-3 py-2.5 text-base/7 font-semibold text-white transition-colors duration-300 hover:bg-[#4540b6]">Log in</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline';
// Dialog and DialogPanel are no longer needed
// import { Dialog, DialogPanel } from '@headlessui/vue';

const navigation = [
  { name: 'Home', href: '/' },
  { name: 'Projects', href: '#projects' },
  { name: 'Pricing', href: '#price' },
  { name: 'About', href: '/about' },
  { name: 'Our Team', href: '#team' },
];

const mobileMenuOpen = ref(false);
const currentPath = ref('');

onMounted(() => {
  currentPath.value = window.location.pathname;
});
</script>
